import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './core/authentication.service';
import { UserAccessService } from './services/user-access.service';

@Injectable({
  providedIn: 'root'
})
export class AppResolver implements Resolve<any> {

  constructor(private userAccessService: UserAccessService, private authenticationService: AuthenticationService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    let currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : '';

    console.log('AppResolver: userId = ' + currentUser.userId);
    if (this.authenticationService.isLoggedIn()) {
      return this.userAccessService.getUserPrivilege()
        .pipe(
          map(data => (data)),
          catchError(error => {
            console.error(`AppResolver: retrieval error occurred for User ID: ${currentUser.userId}`);
            return of({ data: null, error: error });
          })
        );
    }
    return;
  }
}
